import { Checkbox } from '@components/Checkbox/Checkbox';
import { MobileDrawer } from '@components/MobileDrawer/MobileDrawer';
import { MultipleToggle } from '@components/MultipleToggle/MultipleToggle';
import DownloadIcon from '@mui/icons-material/Download';
import { ActionButton } from '@pages/ActionButton';
import { trackingStore } from '@stores/Tracking';
import css from './MobileDownloadDrawer.module.scss';

type MobileDownloadDrawerProps = {
  open: boolean;
  onClose: () => void;
  onOpen: () => void;
  format: 'mp4' | 'gif' | 'both';
  onFormatChange: (format: 'mp4' | 'gif' | 'both') => void;
  removeWatermark: 'yes' | 'no';
  onRemoveWatermarkChange: (value: 'yes' | 'no') => void;
  watermarkCostLabel: string;
  isDownloading: boolean;
  onDownload: () => void;
};

export const MobileDownloadDrawer = ({
  open,
  onClose,
  onOpen,
  format,
  onFormatChange,
  removeWatermark,
  onRemoveWatermarkChange,
  watermarkCostLabel,
  isDownloading,
  onDownload,
}: MobileDownloadDrawerProps) => {
  const checked = removeWatermark === 'yes';

  return (
    <MobileDrawer open={open} onClose={onClose} onOpen={onOpen} frosted>
      <div className={css.content}>
        <div className={css.formatRow}>
          <span className={css.formatLabel}>Download options</span>
          <MultipleToggle
            className={css.compactToggle}
            options={[
              { value: 'mp4', label: 'MP4' },
              { value: 'gif', label: 'GIF' },
              { value: 'both', label: 'Both' },
            ]}
            value={format}
            onChange={(val) => {
              onFormatChange(val);
              trackingStore.momentFormatChanged({ format: val });
            }}
          />
        </div>

        <label className={css.watermarkRow}>
          <Checkbox
            checked={checked}
            onChange={() => {
              const val = checked ? 'no' : 'yes';
              onRemoveWatermarkChange(val);
              trackingStore.momentWatermarkToggled({ removeWatermark: val });
            }}
          />
          <span className={css.watermarkLabel}>{watermarkCostLabel}</span>
        </label>

        <div className={css.hint}>Download may take a while based on your internet connection.</div>

        <ActionButton fullWidth onClick={onDownload} disabled={isDownloading}>
          {isDownloading ? (
            'Downloading...'
          ) : (
            <>
              <DownloadIcon sx={{ fontSize: 18 }} />
              Download
            </>
          )}
        </ActionButton>
      </div>
    </MobileDrawer>
  );
};
